import EventList from '@/components/event/EventList'

export default [
  {
    path: '/evenements',
    name: 'EventList',
    component: EventList,
    meta: {
      parentName: 'Home',
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/eventRouter.js